import { render, staticRenderFns } from "./SkillsSection.vue?vue&type=template&id=66501351&scoped=true&"
import script from "./SkillsSection.vue?vue&type=script&lang=js&"
export * from "./SkillsSection.vue?vue&type=script&lang=js&"
import style0 from "./SkillsSection.vue?vue&type=style&index=0&id=66501351&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66501351",
  null
  
)

export default component.exports